import DatatableFactory from './src/classes/factory.js';

export default (new DatatableFactory());
